/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export type Nullable<T> = T | null;

export function fromNullable <T>(o: Nullable<T>): T {
    if (o !== null) {
        return o;
    }
    throw new Error('the value is null');
}

export function cast<T>(o: any): T {
    return (o as unknown) as T;
}
